/* eslint-disable @typescript-eslint/ban-ts-comment */
import { Box, Typography } from '@mui/material';
import React from 'react';
import type { SxProps } from '@mui/system/styleFunctionSx';
import CoverageCheckbox from '../../customizeQuote/components/CoverageCheckbox';
import type { Category } from '../../../../../workflows/quotes/prime-x/api/types/rater-x-preset';
import CoverageCategory from './CoverageCategories';
import type { Languages } from '../../../../../../i18n/i18n.language-config';
import { useCowbellTranslations } from '../../../../../../i18n/translations';

interface IPrimeXCoverageDetails {
  coverageByCategories: Category[];
  language: Languages;
  containerStyle?: SxProps;
}
const PrimeXCoverageDetails = ({
  coverageByCategories,
  language,
  containerStyle,
}: IPrimeXCoverageDetails) => {
  const { t } = useCowbellTranslations('coverage');
  return (
    <Box sx={{ ...containerStyle }}>
      <Typography variant="h6" style={{ marginBottom: '0.5rem' }}>
        {t('details')}
      </Typography>
      <Box
        sx={{
          display: 'grid',
          alignItems: 'center',
          marginBottom: '1rem',
          gridTemplateColumns: 'repeat(4, auto) 1fr',
          columnGap: 2,
        }}
      >
        <CoverageCheckbox.Mandatory />
        <CoverageCheckbox.Selected disabled />
        <CoverageCheckbox.Available disabled />
        <CoverageCheckbox.NotAvailable />
      </Box>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: '1fr',
          rowGap: 3,
        }}
      >
        {coverageByCategories.map((_category) => (
          <CoverageCategory
            coveragesByCategory={_category}
            language={language}
          />
        ))}
      </Box>
    </Box>
  );
};

export default PrimeXCoverageDetails;
